/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useState } from 'react';
import { useQuery } from 'react-query';
import * as Sentry from '@sentry/react';
import { BusinessInfo } from '../types';
import { ApiContext, ErrorObject } from '../context/ApiContext';
import { API_V2_HOSTNAME_KEY } from '../localStorageKeys';

const useBusinessInformation = () => {
  const { apiFetch } = useContext(ApiContext);

  const { data, isLoading, refetch, isError } = useQuery<BusinessInfo>(
    ['businessInformation'],
    () => apiFetch(`${localStorage.getItem(API_V2_HOSTNAME_KEY)}onboarding/business-info`),
    {
      onError(error: ErrorObject) {
        if (error?.code === 401) return;
        Sentry.captureException(new Error('Error fetching business information'), {
          extra: { error: JSON.stringify(error) },
        });
      },
    }
  );

  return {
    businessInformation: data,
    isError,
    refetchBusinessInformation: refetch,
    currencySymbol: data?.currencySymbol || '',
    currencyISOCode: data?.currencyIsoCode || '',
    isLoading,
  };
};

export default useBusinessInformation;
